var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 12.0002C2.6665 12.0002 5.99984 5.3335 11.8332 5.3335C17.6665 5.3335 20.9998 12.0002 20.9998 12.0002C20.9998 12.0002 17.6665 18.6668 11.8332 18.6668C5.99984 18.6668 2.6665 12.0002 2.6665 12.0002Z",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.833 14.5C13.2137 14.5 14.333 13.3807 14.333 12C14.333 10.6193 13.2137 9.5 11.833 9.5C10.4523 9.5 9.33301 10.6193 9.33301 12C9.33301 13.3807 10.4523 14.5 11.833 14.5Z",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.bcb88476ab655e59bbb171164b30e5f2.svg";
export { ForwardRef as ReactComponent };